// src/utils/decimalFormatter.js
import BigNumber from "bignumber.js";

export const getCurrencyRate = () => {
  return localStorage.getItem("currency_rate");
};

export const setCurrencyRate = (rates) => {
  return localStorage.setItem("currency_rate", rates);
};

export const setUserCurrency = (currency) => {
  localStorage.setItem("user_currency", currency);
};

export const getSymbol = () => {
  return localStorage.getItem("currency_symbol");
};

export const setSymbol = (sym) => {
  return localStorage.setItem("currency_symbol", sym);
};

export const getUserCurrency = () => {
  return localStorage.getItem("user_currency") || "USD";
};

// export function formatDecimal(value, fixedDecimalPlaces = 5) {
//   if (value === null || value === undefined || isNaN(value) || value === "") {
//     return "";
//   }
//   const num = new BigNumber(value);

//   // Format to the fixed number of decimal places
//   const formattedValue = num.toFixed(fixedDecimalPlaces);

//   // Add commas for thousands separators
//   const parts = formattedValue.split(".");
//   parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

//   // Remove unnecessary trailing zeros and the decimal point if there are no decimal places
//   const trimmedValue = parts
//     .join(".")
//     .replace(/(\.\d*?[1-9])0+$/, "$1")
//     .replace(/\.0*$/, "");

//   return trimmedValue;
// }

export function formatDecimal(value, fixedDecimalPlaces = 5, options = {}) {
  if (value === null || value === undefined || value === "") {
    return "";
  }

  const useSymbol = options.symbol !== false;       // default true
  const useConversion = options.conversion !== false; // default true

  const symbol = getSymbol();
  const cleanValue =
    typeof value === "string" ? value.replace(/,/g, "") : value;

  if (isNaN(cleanValue)) {
    return "";
  }

  let num = new BigNumber(cleanValue);
  if (useConversion) {
    const conversionRate = getCurrencyRate();
    num = num.multipliedBy(conversionRate || 1);
  }

  if (options.original || options.full) {
    return num.toString();
  }

  const formattedValue = num.toFixed(fixedDecimalPlaces);
  const parts = formattedValue.split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  const trimmedValue = parts
    .join(".")
    .replace(/(\.\d*?[1-9])0+$/, "$1") // remove trailing zeros after decimal
    .replace(/\.0*$/, "");             // remove ".000..." completely if all zeros

  return useSymbol ? symbol + trimmedValue : trimmedValue;
}

// Function to get the number of decimal places
const getDecimalPlaces = (num) => {
  const parts = num.toString().split(".");
  return parts.length > 1 ? parts[1].length : 0;
};

// Function to format the decimal based on the entry price's decimal places
export function formatTakeProfit(entryPrice, takeProfit) {
  const decimalPlaces = getDecimalPlaces(entryPrice);
  const num = new BigNumber(takeProfit);
  return num.toFixed(decimalPlaces).replace(/(\.[0-9]*[1-9])0+|\.0*$/, "$1");
}

export function setDefaultCurrency() {
  const currency = getUserCurrency();
  const rate = getCurrencyRate();
  const symbol = getSymbol();

  const isValid = currency && rate && symbol;

  if (!isValid) {
    setUserCurrency("USD");
    setCurrencyRate(1);
    setSymbol("$");
  }
}
